import { createContext } from 'react';

import { DeviceService } from '@totem/components/devices/services/types';

interface Context {
  deviceId: string;
  loading: boolean;
  data: DeviceService[];
  action: string;
  actionItem: DeviceService;
  onAction?: (action: string, item: DeviceService) => void;
}

export default createContext<Context>({
  deviceId: '',
  loading: false,
  data: null,
  action: '',
  actionItem: null,
  onAction: () => {},
});
